"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retrieveReportOnFieldsModalOpen = void 0;
const rxjs_1 = require("rxjs");
const redux_observable_1 = require("redux-observable");
const operators_1 = require("rxjs/operators");
const ActionTypes = require("../../actionTypes/reports/fieldsModal");
const RetrievedActions = require("../../actions/reports/retrieved");
const retrieveReportOnFieldsModalOpen = (action$) => action$.pipe((0, redux_observable_1.ofType)(ActionTypes.FIELDS_MODAL_OPEN), (0, operators_1.mergeMap)(({ payload }) => {
    const { reportUuid, type } = payload;
    return reportUuid !== null
        ? (0, rxjs_1.of)(RetrievedActions.retrieveReportRequest(reportUuid, type))
        : rxjs_1.EMPTY;
}));
exports.retrieveReportOnFieldsModalOpen = retrieveReportOnFieldsModalOpen;
//# sourceMappingURL=fieldsModal.js.map